import React from "react";
import "./style.css";

/**
 * NewPageHeader
 * Provides the top gap below the fixed NewNavbar for pages that
 * don't have a NewPageHero. Background is white per design standard.
 */
const NewPageHeader = ({ compact = false }) => {
  return (
    <div
      className={`new-page-header ${compact ? "new-page-header--compact" : ""}`}
      aria-hidden="true"
    ></div>
  );
};

export default NewPageHeader;
